module.exports = __webpack_public_path__ + "img/cart_empty.3c63657c.png";